import styled from 'styled-components';
import { mobileWidth } from '../../style';
import photo from '../../assets/aniversario/foto-20-anos.jpg';
import AnniversaryLogo from '../AnniversaryLogo/index';

export default function AnniversaryPopup() {
    return (
        <PopupStyled aria-label="20 aniversario de La Usina">
            <AnniversaryLink
                href="https://revistagodot.com/20o-aniversario-de-la-usina/"
                aria-label="20 años haciendo teatro: leer el artículo en Revista Godot"
            >
                <PhotoStyled src={photo} width="1600" height="1258" alt="" />
                <LogoStyled>
                    <AnniversaryLogo />
                </LogoStyled>
            </AnniversaryLink>
        </PopupStyled>
    );
}

const PopupStyled = styled.aside`
    --anniversary-brand-color: #f46d2b;
    --anniversary-text-color: #fff;

    position: fixed;
    z-index: 10;
    top: clamp(0.75rem, 2vw, 1.5rem);
    right: max(0.75rem, 2vw, env(safe-area-inset-right));
    width: clamp(15rem, 22.5vw, 21.25rem);
    aspect-ratio: 1;
    font-size: clamp(0.9375rem, 1.75vw, 1.640625rem);

    @media (min-width: 1119px) and (max-width: 1199px) {
        right: 0.25rem;
    }

    @media (max-width: ${mobileWidth}) {
        top: clamp(5rem, 12svh, 8rem);
        width: clamp(8.5rem, 40vw, 12rem);
        font-size: clamp(0.625rem, 2.7vw, 0.8125rem);
    }
`;

const AnniversaryLink = styled.a`
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border: 2.5px solid var(--anniversary-brand-color);
    border-radius: 50%;
    background: #010101;
    box-shadow: 0 0.625rem 1.875rem #0008;

    @media (max-width: ${mobileWidth}) {
        border-width: 2px;
        box-shadow: 0 0.5rem 1.5rem #0008;
    }

    &::after {
        content: '';
        position: absolute;
        inset: 0;
        background: linear-gradient(transparent 40%, #010101bf 68%, #010101f2);
        pointer-events: none;
    }

    &:hover {
        border-color: white;
    }

    &:focus-visible {
        outline: 3px solid white;
        outline-offset: 4px;
    }
`;

const PhotoStyled = styled.img`
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
`;

const LogoStyled = styled.span`
    position: absolute;
    z-index: 1;
    left: 12%;
    right: 12%;
    bottom: 15%;
`;
